{
  "ringOffset": {
    "light": "#FAF8F5",
    "dark": "#131210"
  },
  "focusAccents": ["#A3E635", "#1E1B4B", "#FFFFE0", "#0A0A0A", "#2D70F5"],
  "directions": {
    "ledger": {
      "light": ["#F7F8FA", "#FFFFFF", "#F1F3F6"],
      "dark": ["#0B0D11", "#12151A", "#181C23"]
    },
    "folio": {
      "light": ["#FAF8F5", "#FFFFFF", "#F3F0EA"],
      "dark": ["#1C1A17", "#242220", "#2C2A25"]
    }
  }
}
